import React, { createContext, useEffect, useState } from 'react';
import api from '@services/api';

export const CustomerPermissionsContext = createContext();

export default function CustomerPermissionsProvider({ children }) {
  const [data, setData] = useState({
    canCreateCustomer: true,
    canShowCustomersImport: true,
  });
  useEffect(() => {
    api.get('/admin/permissions/customers').then((response) => {
      setData({
        canCreateCustomer: response.data?.permissions?.can_create_customer,
        canShowCustomersImport: response.data?.permissions?.can_show_customers_import,
      });
      // eslint-disable-next-line no-console
    }).catch((error) => console.error(error));
  }, []);

  return (
    <CustomerPermissionsContext.Provider value={{ ...data }}>
      {children}
    </CustomerPermissionsContext.Provider>
  );
}
